import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";
import { ScrollToTop } from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import SurgeryGuide from "@/pages/SurgeryGuide";
import ProcedureDetail from "@/pages/ProcedureDetail";
import FAQs from "@/pages/FAQs";
import Recovery from "@/pages/Recovery";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="min-h-screen bg-brand-bg font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/surgery-guide" element={<SurgeryGuide />} />
            <Route path="/surgery-guide/:slug" element={<ProcedureDetail />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/recovery" element={<Recovery />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <FloatingButtons />
      </BrowserRouter>
    </div>
  );
}

export default App;
